var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.jobPostings !== undefined
    ? _c(
        "div",
        {
          directives: [
            {
              name: "infinite-scroll",
              rawName: "v-infinite-scroll",
              value: _vm.searchForMore,
              expression: "searchForMore",
            },
          ],
          staticClass: "job-result-list",
          attrs: {
            "infinite-scroll-distance":
              _vm.infiniteScrollDistance !== undefined
                ? _vm.infiniteScrollDistance
                : 500,
          },
        },
        [
          _c(
            "ul",
            _vm._l(_vm.jobPostings, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "clickable",
                  class: {
                    active: index === _vm.activeIndex && _vm.isMobile === false,
                  },
                  attrs: { id: index },
                  on: {
                    click: function ($event) {
                      _vm.setSelectedJobPosting(item), _vm.setActiveIndex(index)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "result-item p-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "result-container d-flex justify-content-between",
                      },
                      [
                        _c("div", { staticClass: "result-item-title" }, [
                          _c(
                            "strong",
                            [
                              _vm.testingEnabled === true &&
                              item.ListOfLinks.length > 0 &&
                              item.NumberOfAds !== undefined
                                ? [_vm._v(_vm._s(item.NumberOfAds + 1 + ": "))]
                                : _vm.testingEnabled === true &&
                                  item.ListOfLinks.length > 0
                                ? [
                                    _vm._v(
                                      _vm._s(item.ListOfLinks.length + ": ")
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(_vm._s(item.Jobtitle)),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "text-grey" }, [
                            _vm._v(_vm._s(item.Company.Name)),
                          ]),
                        ]),
                        _vm.useSavedAdvert
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "result-item-icon col-1 p-0 text-right",
                              },
                              [
                                _c("HeartEmptyFull", {
                                  attrs: { isFull: item.IsSavedAdvert },
                                  on: {
                                    heartClicked: function ($event) {
                                      return _vm.toggleSavedAdvert(item, $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c("div", {
                      staticClass: "result-item-text mt-3",
                      domProps: { innerHTML: _vm._s(item.Text) },
                    }),
                    _c("hr"),
                    _c(
                      "div",
                      {
                        staticClass:
                          "result-item-top d-flex justify-content-between",
                      },
                      [
                        _c("div", { staticClass: "item-top-location" }, [
                          item.Location != "" &&
                          item.Location != null &&
                          !item.Company.Address.City.includes(item.Location)
                            ? _c("span", [_vm._v(_vm._s(item.Location))])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(item.Company.Address.PostalCode) +
                                    " " +
                                    _vm._s(item.Company.Address.City)
                                ),
                              ]),
                        ]),
                        item.Date
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "item-top-date text-brand-medium text-capitalize pl-2 d-none d-lg-block",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.t.jobSearch_V2_Posted) +
                                    ": " +
                                    _vm._s(_vm.formatDate(item.Date))
                                ),
                              ]
                            )
                          : _vm._e(),
                        item.Date
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "item-top-date text-brand-medium text-capitalize pl-2 d-lg-none",
                              },
                              [_vm._v(_vm._s(_vm.formatDate(item.Date)))]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }